import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as Close } from '../../../svgs/close.svg';
import Intro from './Intro';
import Languages from './Languages';
import OurTeam from '../../components/MobileView/OurTeam';
import Education from './Education';
import IntroPlaceHolder from './IntroPlaceHolder';
import { doctorPropType } from '../propTypes';
import { practiceProfilePropType } from '../../propTypes';
import { go } from '../../../routes';
import { goBack } from '../../../routes/utils';
import styles from './mobileDoctorPopUp.module.css';

const MobileDoctorPopUp = ({ isFetching, doctor, clinic, practiceId }) => (
  <div className={styles.container}>
    {isFetching ? (
      <IntroPlaceHolder isFetching={isFetching} />
    ) : (
      <div className={styles.innerContainer}>
        <Intro
          url={doctor.Picture}
          name={doctor.Name}
          title={doctor.Title}
          blurb={doctor.Description}
          goToPracticeBooking={() => go.practiceBooking(practiceId)}
        />
        <div className={styles.mainContent}>
          {doctor.Language.length ? (
            <Languages
              className={styles.languages}
              languages={doctor.Language}
              title="Languages I speak"
            />
          ) : null}
          {doctor.Education.length ? (
            <Education education={doctor.Education} />
          ) : null}
        </div>
        <OurTeam
          team={clinic.Doctors}
          orgId={practiceId}
          title={`Other Doctors at ${clinic.Name}`}
          className={styles.ourTeam}
          onBookNow={() => go.practiceBooking(practiceId)}
        />
      </div>
    )}
    <div className={styles.close} onClick={goBack}>
      <Close className={styles.closeIcon} />
    </div>
  </div>
);

MobileDoctorPopUp.propTypes = {
  practiceId: PropTypes.string.isRequired,
  doctor: doctorPropType.isRequired,
  isFetching: PropTypes.bool.isRequired,
  clinic: practiceProfilePropType.isRequired,
};

export default MobileDoctorPopUp;
